export default "__VITE_ASSET__woAC66Ly__"